module.exports = __webpack_public_path__ + "static/img/keyanImg.31529fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/keyanImg.png
// module id = sE6L
// module chunks = 0